const { EndpointConfig } = require("@amzn/aws-workdocs-web-client-common");

(function() {
    'use strict';

    angular.module('GorillaBoy')
    .controller('gbEditResultModalCtrl', [
        '$rootScope',
        '$scope',
        '$uibModalInstance',
        '$translate',
        'SourceConstant',
        'AppConstants',
        'BrowserService',
        'localStorageService',
        'documentName',
        'isDontShowAgainEnabled',
        'EndpointConfig',
        gbEditResultModalController
    ]);

    function gbEditResultModalController($rootScope, $scope, $uibModalInstance, $translate, SourceConstant, AppConstants, BrowserService, localStorageService, documentName, isDontShowAgainEnabled) {
        $scope.documentName = documentName;
        $scope.isDontShowAgainEnabled = isDontShowAgainEnabled;

        var preferredLanguage = $translate.proposedLanguage() || $translate.use(),
            PROD_CLIENTS_URL = AppConstants.ClientDownloadUrl.ALL[preferredLanguage.toUpperCase()];

        $scope.workDocsAppDownloadUrl = PROD_CLIENTS_URL;

        $scope.closeModal = function() {
            $uibModalInstance.close();
        };

        $scope.isInternalSite = function() {
            return EndpointConfig.isAmazonSite();
        }

        $scope.onDontShowAgainChange = function(){
            localStorageService.set(AppConstants.LocalStorageKeys.DO_NOT_SHOW_EDIT_RESULT_MODAL, $scope.donShowAgain);
        }
    }
}());
